import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BusyOverlay, useBusy } from './busy_component';
import {
  StyleSheet,
  View,
  Text,
  TouchableWithoutFeedback,
} from './base_components';
import LinkText from './buttons/link_text';
import TextButton from './buttons/text_button';
import LinkTextButton from './buttons/link_text_button';

import UserStore from '../stores/user_store';

const styles = StyleSheet.create({
  outside: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    zIndex: 1000,
  },
  rightMenu: {
    position: 'absolute',
    top: '4rem',
    right: 0,
    width: '30rem',
    paddingTop: '2rem',
    paddingBottom: '2rem',
    backgroundColor: '#333',
    borderTopWidth: 1,
    borderTopColor: '#999',
    flexDirection: 'column',
  },
  textLine: {
    paddingLeft: '2rem',
    height: '3rem',
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  text: {
    color: '#bbb',
    fontSize: '1.5rem',
    fontWeight: '500',
  },
  link: {
    paddingLeft: '2rem',
    height: '4rem',
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  linkText: {
    color: '#eee',
    fontSize: '1.5rem',
    fontWeight: '500',
    textDecoration: 'none',
  },
  line: {
    height: 1,
    alignSelf: 'stretch',
    backgroundColor: '#555',
    marginTop: '1rem',
    marginBottom: '1rem',
  },
  buttons: {
    alignSelf: 'flex-end',
    marginTop: '1rem',
    flexDirection: 'row',
  },
  button: {
    marginRight: '1rem',
  },
});

type Props = {
  style?: any;
  onClose: () => void;
};
export default function RightMenu(props: Props) {
  const [is_busy, setBusy, clearBusy] = useBusy();
  const user = UserStore.useUser();
  const org = UserStore.useOrg();
  const custom_domain = UserStore.getCustomDomain();
  const navigate = useNavigate();

  function _onLogoutPress() {
    const yes = window.confirm('Are you sure you want to logout?');
    if (yes && setBusy()) {
      navigate('/');
      UserStore.logout(() => {
        clearBusy();
      });
    }
  }

  return (
    <View style={styles.outside}>
      <TouchableWithoutFeedback
        style={StyleSheet.absoluteFill}
        onPress={props.onClose}
      >
        <View style={StyleSheet.absoluteFill} />
      </TouchableWithoutFeedback>
      <View style={[styles.rightMenu, props.style]}>
        {user?.user_name ? (
          <TextLine>User Name: {user.user_name}</TextLine>
        ) : null}
        <TextLine>Email: {user?.email}</TextLine>
        <TextLine>Org: {org?.org_name}</TextLine>
        <View style={styles.line} />
        <LinkLine text='Account' url='/account' />
        {org?.org_id && org?.is_admin ? (
          <LinkLine text='Organization' url={`/org/${org.org_id}`} />
        ) : null}
        <View style={styles.line} />
        <View style={styles.buttons}>
          {custom_domain ? null : (
            <LinkTextButton
              style={styles.button}
              text='Switch Org'
              url='/org'
            />
          )}
          <TextButton
            style={styles.button}
            text='Sign out'
            onPress={_onLogoutPress}
          />
        </View>
      </View>
      <BusyOverlay isBusy={is_busy} />
    </View>
  );
}
function LinkLine(props) {
  return (
    <LinkText
      style={styles.link}
      textStyle={styles.linkText}
      text={props.text}
      url={props.url}
    />
  );
}
function TextLine(props) {
  return (
    <View style={styles.textLine}>
      <Text style={styles.text}>{props.children}</Text>
    </View>
  );
}
